import { render } from "./MyVouchersForMerchantPage.vue?vue&type=template&id=5c551540&scoped=true"
import script from "./MyVouchersForMerchantPage.vue?vue&type=script&lang=js"
export * from "./MyVouchersForMerchantPage.vue?vue&type=script&lang=js"

import "./MyVouchersForMerchantPage.vue?vue&type=style&index=0&id=5c551540&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c551540"]])

export default __exports__